import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import * as S from './styles';

type Props = {
  children: React.ReactNode;
  placeholder?: React.ReactNode;
  onLoad: () => void;
  rootMargin?: '50px';
};

const InfiniteScroll = ({
  children,
  placeholder,
  onLoad,
  rootMargin,
}: Props) => {
  const [ref, inView] = useInView({ rootMargin });
  const [wasInView, setWasInView] = useState(inView);
  useEffect(() => {
    if (!wasInView && inView) {
      onLoad();
    }
  }, [inView, onLoad, wasInView]);
  useEffect(() => setWasInView(inView), [inView]);
  return (
    <S.InfiniteScroll>
      {children}
      <div ref={ref}>{placeholder || null}</div>
    </S.InfiniteScroll>
  );
};

export default InfiniteScroll;
